// console.log('asdgasdgasdg');
// Location Map
let gmap;
// Container for marker popups
let infowindow;
// Location isotope grid on locations page
let $locationGrid;
// Map location markers
let markers = [];
let markerIcon = {};
let markerIconSelected = {};

const mapStyle = [{ "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f5f5" }] }, { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#bdbdbd" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] }, { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#dadada" }] }, { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }, { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] }, { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#c9c9c9" }] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }];
let userLocationMarker = null;
//order option stuff
function setStoreHourOptions(storeHours) {
    let $ = jQuery;

    // console.log('storeHours', storeHours);

    // Get Schedule dates
    var todaysDate = new Date();
    var tomorrowsDate = new Date().addDays(1);
    var scheduleDates = getDates(todaysDate, new Date().addDays(45));
    var daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
    ];

    for (var i = 0; i < scheduleDates.length; i++) {
        if (i >= 7) break;
        var dayValue =
            scheduleDates[i].getFullYear() +
            "-" +
            zeroPad(scheduleDates[i].getMonth() + 1, 2) +
            "-" +
            zeroPad(scheduleDates[i].getDate(), 2);

        var dayLabel =
            daysOfWeek[scheduleDates[i].getDay()] +
            " " +
            (scheduleDates[i].getMonth() + 1) +
            "/" +
            scheduleDates[i].getDate();

        var isSelected = "";

        if (scheduleDates[i].getTime() === todaysDate.getTime()) {
            dayLabel = "Today";
            isSelected = " selected";
        }

        if (scheduleDates[i].getTime() === tomorrowsDate.getTime()) {
            dayLabel = "Tomorrow";
        }

        var optionHtml =
            '<option value="' + dayValue + '"' + isSelected + ">" +
            dayLabel +
            "</option>";

        $("[data-order-start-order-time-wanted-day]").append(optionHtml);
        $("[data-home-order-time-wanted-day]").append(optionHtml);
    }

    // Set time selections
    var timeSelection = createQuarterHourIntervals();
    for (var ii = 0; ii < timeSelection.length; ii++) {
        $("[data-order-start-order-time-wanted-time]").append(
            '<option value="' +
            convert12to24Hour(timeSelection[ii]) +
            '">' +
            timeSelection[ii] +
            "</option>"
        );

        $("[data-home-order-time-wanted-time]").append(
            '<option value="' +
            convert12to24Hour(timeSelection[ii]) +
            '">' +
            timeSelection[ii] +
            "</option>"
        );
    }

    var currentTime = convert12to24Hour(formatAMPM(roundToNearest15()));
    // console.log(currentTime);
    $("select#start-order-time-wanted-time-slot option").each(function () {
        if ($(this).val() < currentTime) {
            $(this).addClass("hide");
        }
        $("select#start-order-time-wanted-time-slot").val(currentTime);
    });
}
function actionsOnChangingOrderType() {
    let $ = jQuery;
    function updateAvalibleOrderTimes(hourContAttr, schedualedTimeSelect, scheduledDateSelect, inputValue) {
        // console.log('hourContAttr :', hourContAttr);
        // console.log('schedualedTimeSelect', schedualedTimeSelect);
        // console.log('scheduledDateSelect', scheduledDateSelect);
        // console.log('inputValue', inputValue);
        if (scheduledDateSelect == null || scheduledDateSelect === null) {
            return;
        }

        const hoursLabel =
            inputValue === 'dispatch' ? 'dispatch' :
                inputValue === 'curbside' ? 'curbsidepickup' :
                    inputValue === 'pickup' ? 'business' :
                        null;

        let calendarData = null;
        try {
            // Only try to parse if hourContAttr is actually a valid string
            if (hourContAttr && hourContAttr !== 'undefined') {
                calendarData = JSON.parse(hourContAttr);
            }
        } catch (e) {
            console.warn('Invalid or missing calendarhours JSON');
        }

        // SAFEGUARD: If the data failed to parse or is empty, stop the function gracefully
        if (!calendarData) {
            schedualedTimeSelect.find('option[value=""]').remove();
            schedualedTimeSelect.find('option').attr('hidden', true);
            schedualedTimeSelect.prepend('<option value="" selected disabled>No times available</option>');
            schedualedTimeSelect.val('');
            return;
        }

        // THE FIX: Handle the nested { calendar: [...] } structure safely
        const entries = Array.isArray(calendarData) ? calendarData : ((calendarData && calendarData.calendar) || [calendarData]);

        const entry = entries.find(e => {
            if (!e) return false;

            const type = e.type ? e.type.toLowerCase() : '';
            const label = e.label ? e.label.toLowerCase() : '';

            return (
                type.includes(hoursLabel.toLowerCase()) ||
                label.includes(hoursLabel.toLowerCase())
            );
        });

        schedualedTimeSelect.find('option[value=""]').remove();
        schedualedTimeSelect.val('');

        if (!entry) {
            console.warn('No matching entry found for', hoursLabel);
            schedualedTimeSelect.find('option').attr('hidden', true);
            schedualedTimeSelect.prepend('<option value="" selected disabled>No times available</option>');
            return;
        }

        // Prepare Date for comparison
        const [year, month, day] = scheduledDateSelect.split('-');
        const localDate = new Date(`${scheduledDateSelect}T12:00:00`);
        const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const weekdayShort = weekdays[localDate.getDay()];

        const todayRange = (entry.ranges || []).find(
            r => r.weekday.toLowerCase() === weekdayShort.toLowerCase()
        );

        if (!todayRange) {
            schedualedTimeSelect.find('option').attr('hidden', true);
            schedualedTimeSelect.prepend('<option value="" selected disabled>No times available</option>');
            return;
        }

        // Function to convert your time options (like '10:30 am') to 'HH:MM'
        const formatOptionTimeTo24hr = (optionTime) => {
            let [time, modifier] = optionTime.split(' ');
            let [hours, minutes] = time.split(':');

            if (modifier && modifier.toLowerCase() === 'pm' && hours !== '12') {
                hours = parseInt(hours, 10) + 12;
            }
            if (modifier && modifier.toLowerCase() === 'am' && hours === '12') {
                hours = '00'; // Midnight
            }
            return `${String(hours).padStart(2, '0')}:${minutes}`;
        };

        // Function to create a full Date object from the YYYYMMDD HH:MM string
        const createDateFromRange = (dateTimeStr) => {
            const [datePart, timePart] = dateTimeStr.split(' ');
            const Y = datePart.substring(0, 4);
            const M = datePart.substring(4, 6);
            const D = datePart.substring(6, 8);

            return new Date(`${Y}-${M}-${D}T${timePart}:00`);
        };

        // Get the full Date objects for the range boundaries
        const startBoundary = createDateFromRange(todayRange.start);
        const endBoundary = createDateFromRange(todayRange.end);

        let timesAvailable = false;
        if (!schedualedTimeSelect.find('option').length) {
            setStoreHourOptions();
        }

        schedualedTimeSelect.find('option').each(function () {
            const $option = $(this);

            const optionText = $option.text().trim();
            const optionVal = $option.val() ? $option.val().trim() : optionText;

            if (!optionVal) {
                $option.removeAttr('hidden');
                return;
            }

            const optionTime24hr = formatOptionTimeTo24hr(optionText);

            let optionDateTime = new Date(`${scheduledDateSelect}T${optionTime24hr}:00`);

            // Check for rollover
            if (optionDateTime.getHours() < 4 && startBoundary.getHours() >= 10) {
                optionDateTime.setDate(optionDateTime.getDate() + 1);
            }

            const optionTimestamp = optionDateTime.getTime();

            if (optionTimestamp < startBoundary.getTime() || optionTimestamp >= endBoundary.getTime()) {
                $option.attr('hidden', true).addClass('sdgasdg');
            } else {
                $option.removeAttr('hidden').removeClass('sdgasdg');
                timesAvailable = true;
            }
        });

        if (!timesAvailable) {
            schedualedTimeSelect.find('option').attr('hidden', true);
            schedualedTimeSelect.prepend('<option value="" selected disabled>No times available</option>');
            schedualedTimeSelect.find('option[value=""]').removeAttr('hidden');
        } else {
            const $firstVisible = schedualedTimeSelect.find('option:not([hidden])').first();
            if ($firstVisible.length && $firstVisible.attr('value')) {
                schedualedTimeSelect.val($firstVisible.val());
            }
        }
    }
    // Actions on changing the order type
    $('input[name="start-order-order-type"]').change(function () {
        // console.log('i change');

        let inputValue = $('input[name="start-order-order-type"]:checked').val();
        let schedualedTimeSelect = $(this)
            .closest('#toggle-switch-on-off')
            .find('#start-order-time-wanted-time-slot');
        // console.log('schedualedTimeSelect', schedualedTimeSelect);
        let scheduledDateSelect = $(this)
            .closest('#toggle-switch-on-off')
            .find('#start-order-time-wanted-day')
            .val();
        // console.log('scheduledDateSelect', scheduledDateSelect);


        const hourContAttr = $(this)
            .closest('.accordion-content')
            .siblings('ul')
            .attr('calendarhours');
        updateAvalibleOrderTimes(hourContAttr, schedualedTimeSelect, scheduledDateSelect, inputValue);

        const $asapInput = $(this)
            .closest('#toggle-switch-on-off')
            .find('input#start-order-asap');

        if ($asapInput.length) {
            // Element exists
            $asapInput.prop('checked', true);
            // console.log('Found:', $asapInput);
            $(this).closest('#toggle-switch-on-off').find('#start-order-schedule-time').addClass('hide');
        }
        if (
            $('input[name="start-order-order-type"]:checked').val() === "dispatch"
        ) {

            $("[data-search-deliver]").removeClass("hide").attr("aria-hidden", "false");
            $("[data-search-curbside]").addClass("hide").attr("aria-hidden", "true");
            $("#start-order-order-location-search-car-make").val("");
            $("#start-order-order-location-search-car-model").val("");
            $("#start-order-order-location-search-car-color").val("");
            $("#start-order-order-location-search-error-delivery").removeClass('hide').attr("tabindex", "-1").focus();
            $("#start-order-order-location-curbside-error").addClass('hide').removeAttr("tabindex");

        } else if ($('input[name="start-order-order-type"]:checked').val() === "curbside") {
            $("[data-search-deliver]").addClass("hide").attr("aria-hidden", "true");
            $("[data-search-curbside]").removeClass("hide").attr("aria-hidden", "false");
            $("#start-order-order-location-search-building").val("");
            $("#start-order-order-location-search-error-delivery").addClass('hide').removeAttr("tabindex");
            // $("#start-order-order-location-curbside-error").removeClass('hide');

        } else {
            $("[data-search-deliver]").addClass("hide").attr("aria-hidden", "true");
            $("[data-search-curbside]").addClass("hide").attr("aria-hidden", "true");
            $("#start-order-order-location-search-building").val("");
            $("#start-order-order-location-search-car-make").val("");
            $("#start-order-order-location-search-car-model").val("");
            $("#start-order-order-location-search-car-color").val("");
            $("#start-order-order-location-search-error-delivery").addClass('hide').removeAttr("tabindex");
            $("#start-order-order-location-curbside-error").addClass('hide').removeAttr("tabindex");

        }
    });
    // Hide/show schedule elements
    $('input[name="start-order-order-schedule"]').change(function () {
        let inputValue = $('input[name="start-order-order-type"]:checked').val();
        let schedualedTimeSelect = $(this).closest('.location-item')
            .find('#start-order-time-wanted-time-slot');

        let scheduledDateSelect = $(this)
            .closest('.location-item')
            .find('#start-order-time-wanted-day')
            .val();

        if (scheduledDateSelect == null || scheduledDateSelect === null) {
            const today = new Date();

            const formattedDate = today.getFullYear() + '-' +
                String(today.getMonth() + 1).padStart(2, '0') + '-' +
                String(today.getDate()).padStart(2, '0');
            scheduledDateSelect = formattedDate;
        }
        // console.log('scheduledDateSelect', scheduledDateSelect);

        // hoursLabel corresponds to the type in your calendar JSON
        if (scheduledDateSelect) {
            let hourContAttr = $(this)
                .closest('.accordion-content')
                .siblings('ul')
                .attr('calendarhours');
            if (typeof hourContAttr === 'undefined') {
                hourContAttr = $(this).closest('.cont')
                    .find('.accordion')
                    .attr('calendarhours');
                schedualedTimeSelect = $(this).closest('#toggle-switch-on-off').find('#start-order-time-wanted-time-slot');

                // console.log('schedualedTimeSelect', schedualedTimeSelect);
                // console.log('hourContAttr is undefined', $(this).closest('#toggle-switch-on-off'));

            }
            updateAvalibleOrderTimes(hourContAttr, schedualedTimeSelect, scheduledDateSelect, inputValue);
        }

        let $locationItem = $(this).closest('.location-item');
        if ($locationItem.length === 0) {
            $locationItem = $('#menu-select-order-type');
        }


        hoursDataString = $locationItem.find('[data-accordion]').attr('data-all-hours');

        storeHours = JSON.parse(hoursDataString);
        // console.log('storeHours:', hoursDataString);

        const businessHours = storeHours.find(obj => obj.type.toLowerCase() === 'business');

        // setStoreHourOptions(businessHours);

        //
        if (
            $('input[name="start-order-order-schedule"]:checked').val() ==
            "advance"
        ) {
            $("#start-order-schedule-time").removeClass("hide");
        } else {
            $("#start-order-schedule-time").addClass("hide");
        }
    });
    //

    // actions for changing the time wanted (day)
    $("select#start-order-time-wanted-day").change(function () {
        // console.log('i change');
        let inputValue = $('input[name="start-order-order-type"]:checked').val();
        let schedualedTimeSelect = $(this)
            .siblings('#start-order-time-wanted-time-slot');

        let scheduledDateSelect = $(this).val();
        // console.log('scheduledDateSelect', scheduledDateSelect);

        // hoursLabel corresponds to the type in your calendar JSON
        if (scheduledDateSelect) {
            const hourContAttr = $(this)
                .closest('.accordion-content')
                .siblings('ul')
                .attr('calendarhours');
            updateAvalibleOrderTimes(hourContAttr, schedualedTimeSelect, scheduledDateSelect, inputValue);
        }


        if ($('select#start-order-time-wanted-day option[value="' + $(this).val() + '"]').text() == "Today") {
            var currentTime = convert12to24Hour(formatAMPM(roundToNearest15()));
            // console.log(currentTime);
            $("select#start-order-time-wanted-time-slot option").each(
                function () {
                    if ($(this).val() < currentTime) {
                        $(this).addClass("hide");
                    }
                    $("select#start-order-time-wanted-time-slot").val(currentTime);
                }
            );
        } else {
            $("select#start-order-time-wanted-time-slot option").each(
                function () {
                    $(this).removeClass("hide");
                }
            );
        }
    });
    $("select#start-order-time-wanted-day").trigger("change");


}
//location stuff
function getLocationHours($locationItem, calendarsArray, storeID) {
    let $ = jQuery;
    function convertTo12Hour(time24) {
        if (!time24) return '';
        const [hourStr, minute] = time24.split(':');
        let hour = parseInt(hourStr, 10);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        hour = hour % 12 || 12;

        if (minute === '00') {
            return `${hour}${ampm}`;
        } else {
            return `${hour}:${minute}${ampm}`;
        }
    }

    const today = new Date().toLocaleDateString('en-US', { weekday: 'short' });
    const now = new Date();
    const currentHours = now.getHours();
    const currentMinutes = now.getMinutes();

    const $accordion = $locationItem.find('ul[data-accordion]');
    const $template = $accordion.find('[data-tab-content]').first().clone().removeClass('hide');
    $accordion.find('[data-tab-content]').not(':first').remove();
    const allHours = [];

    $.ajax({
        type: 'POST',
        url: ajax_url,
        data: {
            action: 'ajax_get_olo_hours',
            location_id: storeID,
            referer: window.location.href
        },
        success: function (response) {

            // Parse safely
            var rawResult = (typeof response === 'string') ? JSON.parse(response) : response;

            // Force it to be an array
            var result = Array.isArray(rawResult) ? rawResult : (rawResult.calendars || Object.values(rawResult));

            // THE FIX: If the data is trapped inside a nested array (e.g., result[0] is an array), pull it out
            if (result.length > 0 && Array.isArray(result[0])) {
                result = result[0];
            }

            if (Array.isArray(result) && result.length) {
                result.forEach(calendar => {

                    // SAFEGUARD: Make it case-insensitive and check label as a fallback
                    const isBusiness = (calendar.type && calendar.type.toLowerCase() === 'business') || calendar.label === null;

                    if (isBusiness) {

                        const todayRange = calendar.ranges.find(range => range.weekday === today);

                        if (todayRange && todayRange.end) {
                            const [closeHourStr, closeMinuteStr] = todayRange.end.split(' ')[1].split(':');
                            const closeHour = parseInt(closeHourStr, 10);
                            const closeMinute = parseInt(closeMinuteStr, 10);

                            const currentTimeInMinutes = (currentHours * 60) + currentMinutes;
                            const closeTimeInMinutes = (closeHour * 60) + closeMinute;

                            const timeToClose = closeTimeInMinutes - currentTimeInMinutes;

                            if (timeToClose > 0 && timeToClose <= 45) {
                                $locationItem.addClass('hide-asap-option');
                            } else {
                                $locationItem.removeClass('hide-asap-option');
                            }
                        }

                        calendar.ranges.forEach(range => {
                            if (range.start && range.end) {
                                const startTime = convertTo12Hour(range.start.split(' ')[1]);
                                const endTime = convertTo12Hour(range.end.split(' ')[1]);
                                const hoursText = `${startTime} - ${endTime}`;

                                const $newContent = $template.clone();

                                // THE FIX: Add "today" class if the weekday matches today's day
                                if (range.weekday === today) {
                                    $newContent.addClass('today');
                                }

                                $newContent.find('[data-location-hours-type]').text(range.weekday);
                                $newContent.find('[data-location-hours]').text(hoursText);
                                $accordion.find('li.accordion-item .accordion-content').append($newContent);
                            }
                        });

                        allHours.push({
                            type: 'Business',
                            hoursByDay: calendar.ranges.map(range => {
                                return {
                                    day: range.weekday,
                                    start: range.start ? convertTo12Hour(range.start.split(' ')[1]) : 'Closed',
                                    end: range.end ? convertTo12Hour(range.end.split(' ')[1]) : 'Closed'
                                };
                            })
                        });
                    }
                });
            }

            $accordion.attr('data-all-hours', JSON.stringify(allHours));

            // Re-apply the calendarHours attribute based on the raw response
            $locationItem.find('ul.accordion').attr('calendarHours', JSON.stringify(rawResult));
        },
        error: function (jqXHR, textStatus, errorThrown) {
            console.log('AJAX Error:', textStatus, errorThrown);
        }
    });
}
function getLocationOrderTypes($locationItem, location) {
    let $ = jQuery;

    var supportedOrderTypes = [];

    if (location.supportsdispatch == true) supportedOrderTypes.push("dispatch");
    if (location.supportscurbside == true) supportedOrderTypes.push("curbside");
    if (location.canpickup == true) supportedOrderTypes.push("pickup");
    if (location.supportsdinein == true) supportedOrderTypes.push("dinein");
    // console.log('supportedOrderTypes', supportedOrderTypes);
    // console.log('$locationItem', $locationItem);

    supportedOrderTypes.forEach(function (type) {
        $locationItem.find(".supported-order-type-" + type).text("yes");
        // console.log($locationItem.find(".supported-order-type-" + type));
    });
}
function showStoreOrderTypes(thisLocationItem) {
    let $ = jQuery;

    const orderTypes = ["pickup", "curbside", "dinein", "dispatch"];
    orderTypes.forEach((type, index) => {
        const isSupported = thisLocationItem.find(`.supported-order-type-${type}`).text() === "yes";
        const $input = $(`#${type}`);
        const $label = $(`label[for='${type}']`);

        if (!isSupported) {
            $label.hide();

            if ($input.prop("checked")) {
                $input.prop("checked", false);

                // Try to check the next available order type
                for (let i = index + 1; i < orderTypes.length; i++) {
                    const nextType = orderTypes[i];
                    if (thisLocationItem.find(`.supported-order-type-${nextType}`).text() === "yes") {
                        $(`#${nextType}`).prop("checked", true);
                        break;
                    }
                }
            }
        } else {
            $label.removeClass('hide');
        }
    });
}
function intializeDeliverySearchAddress() {
    let $ = jQuery;

    // Autocomplete for location search 
    if ($("#start-order-order-location-search-delivery").length) {
        const inputD = $("#start-order-order-location-search-delivery")[0];
        const options = {
            // componentRestrictions: { country: "us" },
            fields: ["address_components", "geometry"],
            strictBounds: false,
            // types: ['(regions)'],  
        };

        const autocompleteD = new google.maps.places.Autocomplete(
            inputD,
            options
        );
        autocompleteD.addListener("place_changed", function () {
            const place = autocompleteD.getPlace();
            if (place.geometry) {
                // ttmap.systemZoomChange = true;
                // getLocations(place.geometry.location.lat(), place.geometry.location.lng(), '', true);

                ecw_show_loading();

                var nearbyData = {
                    action: "get_nearby_locations",
                    lat: place.geometry.location.lat(),
                    long: place.geometry.location.lng(),
                    distance: "",
                    referer: window.location.href
                };
                // console.log('nearbyData', nearbyData)

                $.ajax({
                    type: "POST",
                    url: ajax_url,
                    data: nearbyData,
                    success: function (response) {
                        // console.log(response);
                        var result = JSON.parse(response);
                        // console.log('result', result);

                        if (result.status == "success" && result.data !== null) {


                            let is_in_dispatch_range = false;
                            let location_item_vendor_id = localStorage.getItem('ecw_customer_store_location_id');

                            result.data.restaurants.forEach(function (restaurant) {
                                if (restaurant.id == location_item_vendor_id) {
                                    is_in_dispatch_range = true;
                                } else {

                                }
                            });
                            // console.log('is_in_dispatch_range', is_in_dispatch_range);

                            if (is_in_dispatch_range) {

                                var components = {};
                                $.each(place.address_components, function (k, v1) {
                                    $.each(v1.types, function (k2, v2) {
                                        components[v2] = v1.long_name;
                                    });
                                });

                                if (components.street_number && components.route) {
                                    $("#start-order-order-location-search-streetaddress").val(
                                        components.street_number + " " + components.route
                                    );
                                }

                                if ('locality' in components) {
                                    $('#start-order-order-location-search-city').val(components.locality);
                                } else if ('administrative_area_level_2' in components) {
                                    $('#start-order-order-location-search-city').val(components.administrative_area_level_2);
                                }

                                $("#start-order-order-location-search-zipcode").val(
                                    components.postal_code
                                );

                                $("#start-order-order-location-search-delivery").removeClass("form-alert");
                                $("[data-delivery-error]").text("");
                                $("#start-order-order-location-search-error-delivery").addClass("hide").removeAttr("tabindex");
                            } else {
                                $("#start-order-order-location-search-delivery").addClass(
                                    "form-alert"
                                );
                                $("[data-delivery-error]").text(
                                    "This address is not within this restaurant's delivery range."
                                );
                                $(
                                    "#start-order-order-location-search-error-delivery"
                                ).removeClass("hide").attr("tabindex", "-1").focus();
                            }
                            // console.log('asdgdsg');
                            ecw_hide_loading();
                        } else {
                            $("#start-order-order-location-search-delivery").addClass(
                                "form-alert"
                            );
                            $("[data-delivery-error]").text(
                                "This address is not within this restaurant's delivery range."
                            );
                            $(
                                "#start-order-order-location-search-error-delivery"
                            ).removeClass("hide").attr("tabindex", "-1").focus();
                            // console.log('asdgdsg');

                            ecw_hide_loading();
                        }
                    },
                    complete: function () {
                        // console.log('asdgdsg');

                        ecw_hide_loading();
                    },
                });
                // console.log(place);
            }
        });
    }
}

function onloadStartOrderStuff() {
    var $ = jQuery.noConflict();
    // console.log('i load');
    if ($('.post-type-archive-locations').length || $('.single-locations').length) {
        // console.log('No cart');
        $(".shopping-cart-icon [data-counter]").addClass("hide");
    }
    $('#location-grid').on('keydown', '[data-store-info-cont] .fav-location-indicator-cont', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).trigger('click');

        }
    });
    $('#location-grid').on('click', '[data-store-info-cont] .order-button, [data-store-info-cont] .fav-location-indicator-cont', function () {
        // console.log('changey boy');
        let dataStoreInfoCont = $(this).closest($('[data-store-info-cont]'));
        if (!dataStoreInfoCont.hasClass('selected-location')) {
            // console.log('stuff')
            // if ($(this).prop('checked')) {
            let distance = dataStoreInfoCont.parent().attr('data-distance');
            let location = dataStoreInfoCont.parent().attr('data-location-name');
            let location_id = dataStoreInfoCont.parent().attr('data-location-id');
            let order_url = dataStoreInfoCont.parent().attr('data-order-url');
            let delivery_url = dataStoreInfoCont.parent().attr('data-delivery-url');
            let delivery_off = dataStoreInfoCont.parent().attr('data-delivery-off');
            let location_address = dataStoreInfoCont.find('.location-address').text();
            let location_phone = dataStoreInfoCont.find('.location-phone a').text();
            // console.log(distance, location, location_id, order_url, delivery_url, delivery_off);

            if (location !== undefined && location_id !== undefined && order_url !== undefined) {
                setLocationLocalStorage(distance, location, location_id, order_url, delivery_url, delivery_off, location_address, location_phone);
            }

            $('[data-store-info-cont]').removeClass('selected-location');
            $('[data-store-info-cont]').parent().removeClass('selected-location');

            dataStoreInfoCont.addClass('selected-location');
            dataStoreInfoCont.parent().addClass('selected-location');

            const $item = dataStoreInfoCont.closest('.location-item');
            const marker = $item.data('marker');

            highlightMarker(marker);

            // console.log('marker', marker);
            if (!marker || !marker.position) {
                console.warn('Missing marker or marker position for selected location.');
                return;
            }
            const newBounds = new google.maps.LatLngBounds();
            newBounds.extend(marker.position);

            gmap.panTo(marker.position);

            // }
        } else {
            // console.log('no stuff')
        }

    });
    // Autocomplete for location search
    if ($(".search-field").length) {
        // console.log('pull all stores');

        // console.log('seach field here');
        const inputD = $(".search-field")[0];
        const options = {
            fields: ["address_components", "geometry"],
            strictBounds: false
        };

        const autocompleteD = new google.maps.places.Autocomplete(inputD, options);

        autocompleteD.addListener("place_changed", function () {
            const place = autocompleteD.getPlace();
            $('[data-no-stores-found]').addClass('hide');
            $('[data-user-need-to-search]').addClass('hide');
            if ($('#g-map').length) {
                // console.log('no');

                if (place.geometry) {
                    start_order_olo_get_nearby_locations(
                        place.geometry.location.lat(),
                        place.geometry.location.lng()
                    );

                    const components = {};
                    $.each(place.address_components, function (k, v1) {
                        $.each(v1.types, function (k2, v2) {
                            components[v2] = v1.long_name;
                        });
                    });
                } else {
                    clearMapAndSearchResults();
                    $('[data-no-stores-found]').removeClass('hide');
                }
            } else {
                // console.log(place.geometry.location.lat(),
                // place.geometry.location.lng()); 
                if (place && place.geometry && place.geometry.location) {
                    localStorage.setItem('ecw_visitor_latitude', place.geometry.location.lat());
                    localStorage.setItem('ecw_visitor_longitude', place.geometry.location.lng());
                    window.location.href = '/locations';

                } else {
                    $('[data-no-stores-found]').removeClass('hide');
                }
            }

        });
        $('input[type="submit"].submit').on('click', function () {
            $('.address-search-form').submit();
        });
        $('.address-search-form').submit(function (e) {
            e.preventDefault();

            const address = $(inputD).val();
            if (!address) return;
            $('[data-no-stores-found]').addClass('hide');
            $('[data-user-need-to-search]').addClass('hide');
            const geocoder = new google.maps.Geocoder();

            if ($('#g-map').length) {
                // Manually geocode the entered address
                geocoder.geocode({ address: address }, function (results, status) {
                    if (status === "OK" && results[0]) {
                        const location = results[0].geometry.location;
                        start_order_olo_get_nearby_locations(
                            location.lat(),
                            location.lng()
                        );
                    } else {
                        clearMapAndSearchResults();
                        $('[data-no-stores-found]').removeClass('hide');
                    }
                });
            } else {
                // Manually geocode the entered address
                geocoder.geocode({ address: address }, function (results, status) {
                    if (status === "OK" && results[0]) {
                        const location = results[0].geometry.location;
                        localStorage.setItem('ecw_visitor_latitude', location.lat());
                        localStorage.setItem('ecw_visitor_longitude', location.lng());
                        window.location.href = '/locations';

                    } else {
                        $('[data-no-stores-found]').removeClass('hide');
                    }
                });
            }

        });
    } else {
    }
}

jQuery(document).ready(function ($) {
    if ($('.single-locations').length) {
        const storeId = $('article').attr('id');
        localStorage.setItem('ecw_customer_store_location_id', storeId);
        // console.log('storeId', storeId);
        onloadStartOrderStuff();

    } else if ($('.post-type-archive-locations').length || $('#other-location-searcher').length) {

        onloadStartOrderStuff();

    }
}); // end jQuery ready

function setLocationLocalStorage(distance, location, location_id, order_url, delivery_url, delivery_off, location_address, location_phone) {
    console.log('setLocationLocalStorage called');
    unsetLocationLocalStorage();
    localStorage.setItem('ecw_visitor_nearest_distance', distance);
    localStorage.setItem('ecw_visitor_nearest_location', location);
    localStorage.setItem('ecw_visitor_nearest_location_id', location_id);

    localStorage.setItem('ecw_visitor_order_url', order_url);
    localStorage.setItem('ecw_visitor_delivery_url', delivery_url);
    localStorage.setItem('ecw_visitor_delivery_off', delivery_off);

    localStorage.setItem('ecw_customer_store_location_id', location_id);
    localStorage.setItem('ecw_customer_store_location_name', location);

    localStorage.setItem('ecw_customer_store_address', location_address);
    localStorage.setItem('ecw_customer_store_phone', location_phone);

    setMenuPageItems();
}

function unsetLocationLocalStorage() {
    // console.log('unsetLocationLocalStorage called')
    localStorage.removeItem('ecw_visitor_nearest_distance');
    localStorage.removeItem('ecw_visitor_nearest_location');
    localStorage.removeItem('ecw_visitor_nearest_location_id');

    localStorage.removeItem('ecw_visitor_order_url');
    localStorage.removeItem('ecw_visitor_delivery_url');
    localStorage.removeItem('ecw_visitor_delivery_off');

    localStorage.removeItem('ecw_visitor_order_url');
    localStorage.removeItem('ecw_visitor_delivery_url');
    localStorage.removeItem('ecw_visitor_delivery_off');
    // Cookies.remove('ecw_visitor_latitude');
    // Cookies.remove('ecw_visitor_longitude');
}
// Init Google Map if on screen
function initMap() {

    let $ = jQuery;

    // console.log('init map');
    userMarkerIcon = {
        url: '/wp-content/themes/wildfire/assets/images/icons/maps-and-flags.png',
        scaledSize: new google.maps.Size(30, 35)
    };
    markerIcon = {
        url: '/wp-content/themes/wildfire/assets/images/icons/icon-map-marker.svg',
        scaledSize: new google.maps.Size(40, 50)
    };
    markerIconSelected = {
        url: '/wp-content/themes/wildfire/assets/images/icons/icon-map-marker-selected.svg',
        scaledSize: new google.maps.Size(50, 60)
    };
    if ($('#g-map-popup').length) {
        let rawLat = localStorage.getItem("ecw_visitor_store_latitude");
        let rawLng = localStorage.getItem("ecw_visitor_store_longitude");

        let singleLat = parseFloat(rawLat);
        let singleLng = parseFloat(rawLng);

        // Only render if the coordinates are actual numbers
        if (!isNaN(singleLat) && !isNaN(singleLng)) {

            let safeMapStyle = typeof mapStyle !== 'undefined' ? mapStyle : [];

            window.gmaps = new google.maps.Map(document.getElementById("g-map-popup"), {
                center: new google.maps.LatLng(singleLat, singleLng),
                zoom: 16,
                mapTypeControl: false,
                fullscreenControl: false,
                styles: safeMapStyle
            });

            let safeIcon = typeof markerIconSelected !== 'undefined' ? markerIconSelected : undefined;

            let singleMarker = new google.maps.Marker({
                position: new google.maps.LatLng(singleLat, singleLng),
                icon: safeIcon,
                map: window.gmaps
            });
        }
    }

    if ($('#g-map-single').length) {
        localStorage.removeItem('ecw_confirm_location');
        localStorage.removeItem('ecw_visitor_store_latitude');
        localStorage.removeItem('ecw_visitor_store_longitude');

        let singleLat = parseFloat($('.location-map.single').attr('data-latitude'));
        let singleLng = parseFloat($('.location-map.single').attr('data-longitude'));
        gmaps = new google.maps.Map(document.getElementById("g-map-single"), {
            center: new google.maps.LatLng(singleLat, singleLng),
            zoom: 16,
            mapTypeControl: false,
            fullscreenControl: false,
            styles: mapStyle
        });

        console.log(singleLat, singleLng);

        let singleMarker = new google.maps.Marker({
            position: new google.maps.LatLng(singleLat, singleLng),
            icon: markerIcon,
            map: gmaps
        });
    }

    if ($('#g-map').length) {
        localStorage.removeItem('ecw_confirm_location');
        localStorage.removeItem('ecw_visitor_store_latitude');
        localStorage.removeItem('ecw_visitor_store_longitude');
        ecw_show_loading();
        // console.log('yes global map :)');

        gmap = new google.maps.Map(document.getElementById("g-map"), {
            // center: new google.maps.LatLng(-33.92, 151.25),
            // zoom: 8
            mapTypeControl: false,
            fullscreenControl: false,
            styles: mapStyle
        });

        infowindow = new google.maps.InfoWindow();
        let bounds = new google.maps.LatLngBounds();

        //saved locations
        if ($('.locations-template-default').length && $('.locations-template-default').find('article').length) {
            const locationID = $('.locations-template-default').find('article').attr('id');
            start_order_olo_get_location(locationID);
            gmap.fitBounds(bounds);
        } else if (localStorage.getItem('ecw_customer_store_location_id')) {
            // console.log('meee');
            start_order_olo_get_location(localStorage.getItem('ecw_customer_store_location_id'));
            gmap.fitBounds(bounds);

        } else if (localStorage.getItem('ecw_visitor_nearest_location_id')) {
            start_order_olo_get_location(localStorage.getItem('ecw_visitor_nearest_location_id'));
            gmap.fitBounds(bounds);

        } //geo location use
        else if (localStorage.getItem('ecw_visitor_latitude') && localStorage.getItem('ecw_visitor_longitude')) {
            start_order_olo_get_nearby_locations(localStorage.getItem('ecw_visitor_latitude'), localStorage.getItem('ecw_visitor_longitude'));
            gmap.fitBounds(bounds);
        }
        else if (localStorage.getItem('ecw_visitor_latitude') && localStorage.getItem('ecw_visitor_longitude')) {
            start_order_olo_get_nearby_locations(localStorage.getItem('ecw_visitor_latitude'), localStorage.getItem('ecw_visitor_longitude'));
            gmap.fitBounds(bounds);

        } else {
            //geolocate  
            let geocoder = new google.maps.Geocoder();

            navigator.permissions.query({ name: 'geolocation' }).then(result => {
                if (result.state === 'granted' || result.state === 'prompt') {
                    //stuff happens here
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            // User allowed geolocation
                            let latitude = position.coords.latitude;
                            let longitude = position.coords.longitude;

                            localStorage.setItem('ecw_user_geolocated', 'true');
                            localStorage.setItem('ecw_visitor_latitude', latitude);
                            localStorage.setItem('ecw_visitor_longitude', longitude);

                            start_order_olo_get_nearby_locations(localStorage.getItem('ecw_visitor_latitude'), localStorage.getItem('ecw_visitor_longitude'));
                            gmap.fitBounds(bounds);
                        },
                        function (error) {
                            localStorage.setItem('ecw_user_geolocated', 'false');
                            localStorage.removeItem('ecw_visitor_latitude');
                            localStorage.removeItem('ecw_visitor_longitude');
                        }
                    );
                } else {
                    console.log('User denied location access previously, load all stores');
                    ecw_show_overloading();
                    $.ajax({
                        type: "POST",
                        url: ajax_url,
                        data: {
                            action: "get_locations_titles"
                        },
                        success: function (response) {
                            if (response.success) {

                                let resultsArray = [];
                                let completed = 0;
                                const total = response.data.length;

                                response.data.forEach(location => {

                                    $.ajax({
                                        type: "POST",
                                        url: ajax_url,
                                        data: {
                                            action: "olo_get_restaurant",
                                            restaurant_id: location.olo_id
                                        },
                                        success: function (response) {
                                            let result = JSON.parse(response);

                                            // store result
                                            resultsArray.push(result);

                                            // console.log("olo_get_restaurant", result);
                                        },
                                        complete: function () {

                                            completed++;
                                            // 👇 when ALL requests are done
                                            if (completed === total) {
                                                // console.log('ALL COMPLETE');
                                                // console.log('All results:', resultsArray);
                                                updateLocationsWithSearchedData(resultsArray);
                                                $('[data-user-need-to-search]').addClass('hide');
                                                ecw_hide_overloading();
                                            }
                                        }
                                    });

                                });
                            }
                        },
                        error: function (err) {
                            console.error('AJAX error:', err);
                            ecw_hide_loading();
                        }
                    });


                }
            });
            // console.log('i no have location');

            $('[data-user-need-to-search]').removeClass('hide');
            // Set default bounds to the East Coast of the U.S.
            const eastCoastBounds = new google.maps.LatLngBounds(
                new google.maps.LatLng(25.0, -82.5), // Southwest corner (Florida)
                new google.maps.LatLng(45.0, -66.0)  // Northeast corner (Maine)
            );

            gmap.fitBounds(eastCoastBounds);

        }


    }
    // console.log('end of initMap');

}
function highlightMarker(marker) {
    // console.log('highlightMarker called', marker);
    let $ = jQuery;
    if (marker && typeof marker.setIcon === 'function') {
        // infowindow.close(); 

        for (let m = 0; m < markers.length; m++) {
            // Check if this marker is the user's location marker
            if (userLocationMarker && markers[m] === userLocationMarker) {
                markers[m].setIcon(userMarkerIcon);
            } else {
                markers[m].setIcon(markerIcon); // Reset others to default restaurant icon
            }
        }
        marker.setIcon(markerIconSelected);
        // google.maps.event.trigger(marker, 'click');

        // scrollToSelectedMarker();
    } else {
        let markerIndex = $('#location-grid .post-' + localStorage.getItem('ecw_visitor_nearest_location_id')).index() + 1;
        // console.log(markers);

        for (let m = 0; m < markers.length; m++) {
            markers[m].setIcon(markerIcon);
        }

        if (markers.length && typeof markers[markerIndex] !== 'undefined') {
            markers[markerIndex].setIcon(markerIconSelected);
            // scrollToSelectedMarker();
        }
    }

}
function clearMapAndSearchResults() {
    let $ = jQuery;

    // Clear previous markers from map
    if (markers && markers.length) {
        for (let i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }
        markers = [];
    }

    // Clear location items
    $('#location-grid [data-location-item-template]').not('.hide').remove();
}

function scrollToSelectedMarker() {
    // console.log('scrollToSelectedMarker called'); 
    let $ = jQuery;

    setTimeout(function () {
        if (window.innerWidth < 1025) {
            $('.order-location-list').scrollTo(0, 0, { duration: 50 });

        } else {
            const nearestId = localStorage.getItem('ecw_visitor_nearest_location_id');
            if (nearestId && $('.order-location-list .post-' + nearestId).length) {
                // Faster scroll: 150ms duration
                $('.order-location-list').scrollTo('.post-' + nearestId, 50);
            }
        }

    }, 50);

}
function updateLocationsWithSearchedData(restaurants, usersLat, usersLng) {
    let $ = jQuery;
    // console.log('restaurants', restaurants, usersLat, usersLng);
    // unsetLocationLocalStorage();

    clearMapAndSearchResults();

    // Reset map bounds
    let bounds = new google.maps.LatLngBounds();

    // Add a marker for the user's current location
    if (usersLat && usersLng) {
        const userPosition = { lat: parseFloat(usersLat), lng: parseFloat(usersLng) };
        userLocationMarker = new google.maps.Marker({
            position: userPosition,
            icon: userMarkerIcon,
            map: gmap,
            title: "Your Location"
        });
        // console.log('userMarkerIcon', userMarkerIcon);
        markers.push(userLocationMarker); // Add to your global markers array if you have one
        bounds.extend(userPosition); // Extend bounds to include user's location
    }


    restaurants.forEach((location, index) => {
        // console.log('location', location);

        const name = location.name;
        const lat = location.latitude;
        const lng = location.longitude;
        const id = location.id;
        const rawAddress = location.streetaddress + ', ' + location.state + ' ' + location.zip;
        const phone = location.telephone;
        const orderOloURL = location.mobileurl;
        const supportsbaskettransfers = location.supportsbaskettransfers;

        const orderWPURL = new URL(orderOloURL, window.location.origin)
            .pathname
            .replace('/menu/', '/locations/');

        const calendarsArray = location.calendars;

        let marker = null;


        //map stuff
        if (lat && lng) {
            const position = { lat: parseFloat(lat), lng: parseFloat(lng) };
            marker = new google.maps.Marker({
                position,
                icon: markerIcon, // This would be your restaurant marker icon
                map: gmap
            });

            markers.push(marker);
            bounds.extend(position);

            google.maps.event.addListener(marker, 'click', () => {
                // console.log('i clicksss', marker);
                infowindow.setContent(`
                    <div class="title"><strong>${name}</strong></div>
                    <div class="address">${rawAddress}</div> 
                    <div class="phone">${phone}</div>
                    <div class="info"><a class="button info-button" tabindex="0" href="${orderWPURL}">MORE STORE INFO</a></div>
                `);
                infowindow.open(gmap, marker);

                $('#location-grid .location-item').eq(index + 1).find('[data-store-info-cont] .order-button').click();
            });
        }

        // Build location item in UI
        const $locationItem = $('#location-grid [data-location-item-template].hide').clone();
        //temp catering stuff
        if (id === 34919 || id === 24187 || id === 24194) {
            // console.log('i cater');
            $locationItem.find('[data-olo-catering]').removeClass('hide');
            var cleanSlug = location.slug.replace('-amp', '');
            var cateringUrl = 'https://eastcoastwingscatering.olo.com/menu/' + cleanSlug;
            $locationItem
                .find('[data-olo-catering] a')
                .attr('href', cateringUrl);
        } else {
            $locationItem.find('[data-olo-catering]').addClass('hide');
        }
        //END temp catering stuff
        if (location.availabilitymessage) {
            $locationItem.find('[data-availabilitymessage]').removeClass('hide').text(location.availabilitymessage);
        } else {
            $locationItem.find('[data-availabilitymessage]').addClass('hide');

        }
        $locationItem
            .attr({
                id: `location-${id}`,
                'data-location-id': id,
                'data-latitude': lat,
                'data-longitude': lng,
                'data-location-name': name,
                'data-location-details': orderOloURL,
                'data-order-url': orderOloURL,
                'supportsbaskettransfers': supportsbaskettransfers
            })
            .addClass(`post-${id}`)
            .removeClass('hide');

        $locationItem.find('[data-store-info-cont]').attr({
            id: `location-select-${id}`,
            // value: `location-id-${id}`
        });

        // $locationItem.find('[data-store-info-cont]').attr('for', `location-select-${id}`);
        $locationItem.find('[data-location-name]').text(name);
        $locationItem.find('p.location-address').text(rawAddress);
        $locationItem.find('a[data-phone-number]').text(phone).attr('href', `tel:${phone}`);
        $locationItem.find('.order-button').attr({
            'data-store-url': orderOloURL,
            'data-store-number': id,
            'aria-controls': 'accordion-content-1-' + id
        });
        $locationItem.find('.order-from-here').attr('id', 'accordion-content-1-' + id);
        $locationItem.find('a.store-link').attr('href', orderWPURL);

        //phased rollout
        $locationItem.find('a[olo-store-url]').attr('href', orderOloURL);
        let experienceOptInStoresNums = [];

        if (experienceOptInStores !== null) {
            experienceOptInStoresNums = experienceOptInStores.map(Number);
        }


        if (experienceOptInStores === null || (experienceOptInStores !== null && experienceOptInStoresNums.includes(Number(id)))) {
            $locationItem.find('a[olo-store-url]').addClass('hide');
            $locationItem.find('button[data-store-url].order-button').removeClass('hide');
            // console.log('i am olo store', name, ' ', id);
        } else {
            $locationItem.find('a[olo-store-url]').removeClass('hide');
            $locationItem.find('button[data-store-url].order-button').addClass('hide');
            // console.log('i am not olo store', name, ' ', id);
        }


        //order types
        getLocationOrderTypes($locationItem, location);
        //store hours
        getLocationHours($locationItem, calendarsArray, id);

        // Store marker directly on the element
        $locationItem.data('marker', marker);

        //Store hours accordian
        $locationItem.find('.store-hours').attr('aria-controls', 'accordion-content-2-' + id);
        $locationItem.find('.store-hours').next('.accordion-content').attr('id', 'accordion-content-2-' + id);
        $locationItem.find('.accordion-title').on("keydown", function (e) {
            if (e.key === "Enter" || e.key === " " || e.keyCode === 13 || e.keyCode === 32) {
                // console.log('i click');
                e.preventDefault();
                $(this).trigger('click');
            }
        });
        $locationItem.find('.accordion-title').on("click", function (e) {
            if (e.type === "click") {
                // console.log('i click');
                e.preventDefault();

                let $button = $(this);
                let $content = $button.parent().next('.accordion-content');

                let isOpen = $button.attr("aria-expanded") === "true";

                // Toggle classes
                $content.toggleClass("hide");
                $button.toggleClass("open");

                // Update ARIA attributes
                $button.attr("aria-expanded", !isOpen);
                $content.attr("aria-hidden", isOpen);
            }
        });


        // Select A Location
        $locationItem.find(".order-button, .fav-location-indicator-cont").click(function () {
            // console.log("clicked ORDER FROM HERE button", $locationItem);
            localStorage.removeItem('ecw_confirm_location');
            localStorage.removeItem('ecw_visitor_store_latitude');
            localStorage.removeItem('ecw_visitor_store_longitude');



            $locationItem.find('[data-search-deliver]').addClass('hide').attr("aria-hidden", "true");
            $locationItem.find('[data-search-curbside]').addClass('hide').attr("aria-hidden", "true");
            if ($(this).is('.fav-location-indicator-cont')) {
                $locationItem.find('.order-button').addClass('open');
                $locationItem.find('[data-attach-order-type-embed]').removeClass('hide');
            }

            // hideFakeMenuIfAddedLocation();
            if (experienceOptInStores === null || (experienceOptInStores !== null && experienceOptInStores.includes($(this).attr("data-store-number")))) {
                $('.location-item').find('#start-order-select-order-type-embedded').addClass('hide');
                let thisOrderTypeContainer = $(this).closest(".location-item");

                $("#start-order-order-location-search-error-delivery").addClass("hide").removeAttr("tabindex");
                $("#start-order-order-location-search-error").addClass("hide").removeAttr("tabindex");

                // display order type info options
                if (!thisOrderTypeContainer.hasClass("last-selected")) {
                    $(".location-item #start-order-select-order-type-embedded:not(.template)").remove();
                    $("#start-order-select-order-type-embedded.template").clone().appendTo(thisOrderTypeContainer.find('[data-attach-order-type-embed]')
                    ).removeClass('template');
                }
                thisOrderTypeContainer.find("#start-order-select-order-type-embedded:not(.template)").removeClass("hide");


                if (thisOrderTypeContainer.hasClass("location-order-type-container-hidden")) {
                    thisOrderTypeContainer.removeClass("location-order-type-container-hidden");
                } else {
                    thisOrderTypeContainer.addClass("location-order-type-container-hidden");
                }

                //
                let thisLocationItem = $(this).closest(".location-item");

                $(".start-order-order-type-label").show();
                $("#pickup").prop("checked", true).change();

                //hide/show this stores order options
                showStoreOrderTypes(thisLocationItem);
                // Actions on changing the order type
                actionsOnChangingOrderType();
                // Autocomplete for location search
                intializeDeliverySearchAddress();

                //start order buttons
                $("#start-order-select-order-type-button").click(function () {
                    localStorage.removeItem('ecw_confirm_location');
                    // console.log('i start order', $(this).closest('.location-item'));
                    // $("#start-order-order-location-search-error-delivery").addClass("hide");
                    //         $("#start-order-order-location-search-error").addClass("hide");
                    //$('#' + view_context + '-select-order-type').foundation('close');

                    var validAddress = true;
                    var isDelivery = Boolean(
                        $('input[name="start-order-order-type"]:checked').val() == "dispatch"
                    );
                    // console.log("location id");
                    // console.log($(this).closest(".location-item").attr("data-location-id"));
                    var vendorid = $(this)
                        .closest(".location-item")
                        .attr("data-location-id");
                    var supportsbaskettransfers =
                        $(this)
                            .closest(".location-item")
                            .attr("supportsbaskettransfers");

                    //set local storage items
                    let distance = $(this).closest(".location-item").attr('data-distance');
                    let location = $(this).closest(".location-item").attr('data-location-name');
                    let order_url = $(this).closest(".location-item").attr('data-order-url');
                    let delivery_url = $(this).closest(".location-item").attr('data-delivery-url');
                    let delivery_off = $(this).closest(".location-item").attr('data-delivery-off');
                    let location_address = $(this).closest(".location-item").find('.location-address').text();
                    let location_phone = $(this).closest(".location-item").find('.location-phone a').text();

                    // console.log('i start order', distance, location, order_url, delivery_url, delivery_off, location_address, location_phone);

                    if (location !== undefined && vendorid !== undefined && order_url !== undefined) {
                        setLocationLocalStorage(distance, location, vendorid, order_url, delivery_url, delivery_off, location_address, location_phone);
                    }
                    // Delivery requires a full address, thus fails validation if no street address is present
                    if (
                        isDelivery &&
                        !($("#start-order-order-location-search-streetaddress").val() || "").length
                    ) {
                        validAddress = false;
                    }
                    //curbisde stuff
                    var validCurbside = true;

                    let isCurbside = Boolean(
                        $('input[name="start-order-order-type"]:checked').val() == "curbside"
                    );
                    if (isCurbside) {
                        if (
                            !($("#start-order-order-location-search-car-make").val() || "").length ||
                            !($("#start-order-order-location-search-car-model").val() || "").length ||
                            !($("#start-order-order-location-search-car-color").val() || "").length
                        ) {
                            // console.log('didnt fill out car');
                            validCurbside = false;
                            validAddress = true;
                        } else {
                            let carMake = $("#start-order-order-location-search-car-make").val();
                            localStorage.setItem("ecw_customer_car_make", carMake);
                            let carModel = $("#start-order-order-location-search-car-model").val();
                            localStorage.setItem("ecw_customer_car_model", carModel);
                            let carColor = $("#start-order-order-location-search-car-color").val();
                            localStorage.setItem("ecw_customer_car_color", carColor);

                            validCurbside = true;

                        }
                    }

                    //end of curbside stuff

                    $("#start-order-order-location-search").removeClass("form-alert");
                    $("#start-order-order-location-sea  rch-error").addClass("hide");

                    if (!validAddress) {
                        $("#start-order-order-location-search").addClass("form-alert");
                        $("#start-order-order-location-curbside-error").addClass("hide").removeAttr("tabindex");
                        $("#start-order-order-location-search-error").removeClass("hide").attr("tabindex", "-1").focus();
                    } else if (!validCurbside) {
                        $("#start-order-order-location-search").addClass("form-alert");
                        $("#start-order-order-location-search-error").addClass("hide").removeAttr("tabindex");
                        $("#start-order-order-location-curbside-error").removeClass("hide").attr("tabindex", "-1").focus();
                    } else {
                        // console.log('valid address/curbside');
                        ecw_show_loading();
                        setAddressComponents("start-order");

                        // console.log(vendorid, supportsbaskettransfers, false, "start-order")
                        selectLocation(
                            vendorid,
                            supportsbaskettransfers,
                            false,
                            "start-order"
                        );

                    }
                });

            } else {
                // Opt-out store, go to store page
                // console.log('Opt-out store, go to store page');
                // ecw_show_loading();
                // window.location = $(this).attr('data-store-url');
            }
            const headerOffset = 65; // adjust as needed
            setTimeout(function () {
                if (window.innerWidth < 1025) {
                    $('html, body').animate({
                        scrollTop: $($locationItem).offset().top - headerOffset
                    }, 600);
                }

            }, 200);

        });
        $('#location-grid').append($locationItem);
    });
    if (localStorage.getItem('ecw_customer_store_location_id')) {
        // console.log('meeeesss')
        $('.location-item [data-store-info-cont]#location-select-' + localStorage.getItem('ecw_customer_store_location_id') + ' .order-button').click();
    } else if (localStorage.getItem('ecw_visitor_nearest_location_id')) {
        $('.location-item [data-store-info-cont]#location-select-' + localStorage.getItem('ecw_visitor_nearest_location_id') + ' .order-button').click();
    }
    ecw_hide_loading();
    // console.log('ahhh')

    // Fit map to new markers
    gmap.fitBounds(bounds);
    // Then check the zoom level
    const minZoomFor30Miles = 15;

    google.maps.event.addListenerOnce(gmap, 'bounds_changed', function () {
        if (gmap.getZoom() > minZoomFor30Miles) {
            gmap.setZoom(minZoomFor30Miles);
        }
    });
}
function start_order_olo_get_location(location_id) {
    // console.log('start_order_olo_get_location called');
    ecw_show_loading();
    let $ = jQuery;
    // console.log('location_id', location_id);

    $.ajax({
        type: "POST",
        url: ajax_url,
        data: {
            action: "olo_get_restaurant",
            restaurant_id: location_id,
            get_calendar: true,
            referer: window.location.href
        },
        success: function (response) {
            let result = JSON.parse(response);
            // console.log("start_order_olo_get_location", result);
            localStorage.setItem('ecw_visitor_store_latitude', result.latitude);
            localStorage.setItem('ecw_visitor_store_longitude', result.longitude);
            if ($('.single-locations').length) {
                resultsArray = [result];
                // console.log('resultsArray', resultsArray);

                updateLocationsWithSearchedData(resultsArray, result.latitude, result.longitude);
            } else if ($('#g-map').length) {
                start_order_olo_get_nearby_locations(result.latitude, result.longitude, result.distance);

            } else {
                // console.log('heheh');
                // updateLocationsWithSearchedData(resultsArray, result.latitude, result.longitude);

            }
        },
    });
}
function start_order_olo_get_nearby_locations(lat, lng, dist) {
    // console.log("start_order_olo_get_nearby_locations called", lat, lng, dist);

    ecw_show_loading();

    // console.log("getLocations", lat, lng, dist);
    let $ = jQuery;

    let nearbyData = {
        action: "get_nearby_locations",
        lat: lat,
        long: lng,
        distance: dist,
        referer: window.location.href
    };

    $.ajax({
        type: "POST",
        url: ajax_url,
        data: nearbyData,
        success: function (response) {
            // console.log(response);
            let result = JSON.parse(response);
            // console.log('result', result);
            userHasSearched = true;
            if (result.status == "success" && result.data !== null) {

                if (!result.data.restaurants || result.data.restaurants.length === 0) {

                    clearMapAndSearchResults();
                    $('[data-no-stores-found]').removeClass('hide');
                    $('[data-user-need-to-search]').addClass('hide');
                    // console.log('asdgdsg');

                    ecw_hide_loading();

                } else {
                    $('[data-no-stores-found]').addClass('hide');
                    $('[data-user-need-to-search]').addClass('hide');
                    // if ($('.single-locations').length) {
                    //     const firstRestaurantArray = [result.data.restaurants[0]];
                    //     updateLocationsWithSearchedData(firstRestaurantArray, lat, lng);
                    // } else {
                    updateLocationsWithSearchedData(result.data.restaurants, lat, lng);
                    // }
                }

            } else if (result.status == "failure" && $('body.single-locations').length > 0) {
                const $locationItem = $('#location-grid [data-location-item-template].hide');
                $locationItem.after('<h2>Store temporarily unavailable</h2><div style="height:100px" aria-hidden="true" class="wp-block-spacer is-style-32px"></div><p class="is-style-subheading">At this time, you cannot place orders at this store</p>');
                // console.log('asdgdsg');

                ecw_hide_loading();
            } else {
                // console.log('no stores');
                clearMapAndSearchResults();
                $('[data-user-need-to-search]').addClass('hide');
                $('[data-no-stores-found]').removeClass('hide');
                // console.log('asdgdsg');

                ecw_hide_loading();
            }
        },
        complete: function () { },
    });
}